import script from "./SfxTopNavigationManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxTopNavigationManager.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QToolbar});
